import "./svg/touch-pointer.svg"

export default {
    name: "touch-pointer",
    viewBox: "24 24",
}
